import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowOutword from '../../atoms/Icons/ArrowOutword';
import {
  DottedText,
  Tooltip,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import moment from 'moment';
import CheckCircle from '../../atoms/Icons/checkCircle';
import loader from '../../../../public/Images/PopupIcons/loader.gif';
import { CardData } from '../../../pages/ExperiencePage';
import {
  COMPENSATION_TRANSPARENCY_REPORT,
  DRAFT_SELECTED,
  GAG_CLAUSE_REPORT,
  INTER_CONTRACT_REPORT,
  PURCHASING_STANDARDS_REPORT,
  // REGULATORY_COMPLIANCE_REPORT,
} from '../../../core-utils/routes';
import { handleDownloadReport } from '../../../core-utils/helper-utils/contractReportHelper';
import { useStores } from '../../../stores';
import { AlertColor as MuiColor } from '@mui/material/Alert';

import Snackbar from '../../atoms/Snackbar';
import Unfinished from '../../atoms/Icons/Unfinished';
import NoTabsData from '../../molecules/NoTabsData';
import { truncateString } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';
import axios from 'axios';
import properties from '../../../core-utils/properties';
import Loader from '../../molecules/Loader';

interface ComplianceReportsProps {
  egNid: string;
  incurredStartDate: any;
  incurredEndDate: any;
  paidStartDate: any;
  paidEndDate: any;
  isPlanDatesFetched: any;
  aggregationParameter: any;
}

const useStyles = makeStyles()({
  scrollableTabContent: {
    height: '540px',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  reportsMainContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  reportsHeader: {
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '8px',
    height: '44px',
    backgroundColor: `${patientAccessTheme.palette.grey[100]}`,
  },
  innerTabHeader: {
    display: 'flex',
    gap: '15px',
  },
  mainInnerContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  organisationRow: {
    display: 'flex',
    backgroundColor: 'white',
    justifyContent: 'space-between',
    gap: '12px',
    marginTop: '10px',
  },
  organisationItem: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '5px',
    flex: 1,
  },
  reportMainContainer: {
    display: 'grid',
    padding: '12px 16px 16px 16px',
    gap: '16px',
    width: '100%',
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  reportsLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '4px',
    width: '233px',
  },
  reportsExpandContainer: {
    gridColumn: '2',
    cursor: 'pointer',
  },
  cardInnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '8px',
  },
  serviceAgreementSection: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    minWidth: '285px',
    padding: '14px',
    borderRight: `1px solid ${patientAccessTheme.palette.grey[300]}`,
  },
  noDataBottomCardContainer: {
    // border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    // borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '823px',
    height: '532px',
    margin: '10px',
  },
});

const DraftsTab: React.FC<ComplianceReportsProps> = ({
  egNid,
  incurredStartDate,
  incurredEndDate,
  paidStartDate,
  paidEndDate,
  aggregationParameter,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const employerGroupStore = useStores().employerGroupStore;
  const contractStore = useStores().contractAiqStore;
  const abortController = new AbortController();

  // useStates
  const [loading, setLoading] = useState(true);
  const [mainLoader] = useState<any>(<Loader height="400px" />);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [expandedCards, setExpandedCards] = useState<Record<number, boolean>>(
    {},
  );
  // const [drafts, setDrafts] = useState<any[]>([]);

  const [cardsData, setCardsData] = useState<CardData[]>([]);

  const handleDraftOnClick = (card: any) => {
    contractStore.setDraftId(card.contractId);
    navigate(DRAFT_SELECTED);
  };
  const reportHandleOnClick = (
    reportName: string,
    contractId?: string,
    status?: any,
    compareId?: string,
    card?: any,
  ) => {
    let path;
    contractStore.setDraftId(contractId!);
    if (status === 'Ready') {
      switch (reportName) {
        case 'Gag Clause Prohibition Compliance Check':
          path = GAG_CLAUSE_REPORT;
          break;
        case 'Purchasing Standards Compliance Review':
          path = PURCHASING_STANDARDS_REPORT;
          break;
        case 'Compensation Transparency Compliance Check':
          path = COMPENSATION_TRANSPARENCY_REPORT;
          break;
        case 'Comparison with Stop Loss Agreement':
        case 'Comparison with Administrative Service Agreement':
        case 'Comparison with Summary Plan Description':
        case 'Comparison with Administrative Service Agreement':
          path = INTER_CONTRACT_REPORT;
          break;
        case 'Commercial Evaluation':
          handleDownloadFeeScheduleReport(contractId!);
          return;
        case 'Provision Matrix':
          handleDownloadReport(
            'provisionMatrixReport',
            employerGroupStore?.employerGroupResponseData
              ?.employer_group_name[0],
            contractId! || contractStore?.draftId,
            handleOpenSnackBar,
          );
          return;
        case 'Key Terms':
          navigate('/draft-selected', {
            state: {
              isDraft: true,
              isExperience: true,
              draftName: card.service_agreement_name,
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Key Terms',
            },
          });
          return;
        case 'Red Flag Checks':
          navigate('/draft-selected', {
            state: {
              isDraft: true,
              isExperience: true,
              contract: card.service_agreement_name,
              draftName: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Red Flags',
            },
          });
          return;
        case 'Missing Checks':
          navigate('/draft-selected', {
            state: {
              isDraft: true,
              isExperience: true,
              draftName: card.service_agreement_name,
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Missing Provisions',
            },
          });
          return;
        case 'Summary of Findings':
          navigate('/draft-selected', {
            state: {
              isDraft: true,
              isExperience: true,
              draftName: card.service_agreement_name,
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Summary',
            },
          });
          return;
        case 'Fees':
          navigate('/draft-selected', {
            state: {
              isDraft: true,
              isExperience: true,
              draftName: card.service_agreement_name,
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Fees',
            },
          });
          return;
        case 'Stop loss':
          navigate('/draft-selected', {
            state: {
              isDraft: true,
              isExperience: true,
              draftName: card.service_agreement_name,
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Stop loss',
            },
          });
          return;
        default:
          navigate('/compliance-report');
          return;
      }
      navigate(path, {
        state: {
          reportName,
          document: `Experience`,
          healthcarePartner: card?.health_care_partner_name,
          contract: card?.service_agreement_name,
          contractId,
          isDraft: true,
          isReportsTab: true,
          compareId: compareId,
          isExperience: true,
        },
      });
    }
  };
  const handleDownloadFeeScheduleReport = (contractId: string) => {
    handleDownloadReport(
      'feeEvaluationReport',
      employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
      contractId || contractStore?.draftId,
      handleOpenSnackBar,
    );
  };
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };
  const getAllDrafts = async () => {
    try {
      setLoading(true);

      const res = await axios.post(
        properties.aiqBaseUrl +
          properties.draftBaseUrl +
          properties.getAllDrafts,
        { eg_nid: egNid },
        { signal: abortController.signal },
      );

      if (res.status === 200) {
        const data = res?.data?.data || [];
        // setDrafts(data);
        const mappedDrafts = data.map((item: any) => {
          const evaluations = [
            ...(item?.reports || []).map((report: string) => ({
              report_name: report,
              status: 'Ready',
              contract_id: item?._id,
            })),
            ...(item?.features || []).map((feature: string) => ({
              report_name: feature,
              status: 'Ready',
              contract_id: item?._id,
            })),
          ];

          return {
            contractId: item?._id,
            status: item?.status,
            service_agreement_name:
              item?.service_agreement_id?.service_agreement_name || '',
            health_care_partner_name: item?.health_care_partner || '',
            effective_date: item?.createdAt,
            documents: [item?.document_name],
            evaluations,
            // draftData: item,
          };
        });

        setCardsData(mappedDrafts);
      }
    } catch (error: any) {
      handleOpenSnackBar(
        error.response?.data?.error || 'Error Fetching Drafts',
        'error',
        6000,
      );
    } finally {
      setLoading(false);
    }
  };
  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  useEffect(() => {
    getAllDrafts();
  }, [
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  ]);
  return loading ? (
    mainLoader
  ) : (
    <Grid className={classes.scrollableTabContent}>
      <Grid className={classes.reportsMainContent}>
        {cardsData?.length > 0 && (
          <Grid className={classes.reportsHeader}>
            <Grid className={classes.innerTabHeader}>
              <Typography
                fontSize="12px"
                fontType="medium"
                styleProps={{
                  width: '285px',
                  padding: '12px',
                  borderRight: `1px solid ${patientAccessTheme.palette.grey[300]}`,
                }}
              >
                Benefit Documents & Contracts
              </Typography>
              <Typography
                fontSize="12px"
                fontType="medium"
                styleProps={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
                onClick={() => {
                  navigate('/compliance-report');
                }}
              >
                Reports
                {/* <ArrowOutword cursor={'pointer'} /> */}
              </Typography>
            </Grid>
          </Grid>
        )}
        <Grid className={classes.mainInnerContent}>
          {cardsData?.length > 0 ? (
            cardsData?.map((card, index) => {
              const showAll = expandedCards[index] || false;
              return (
                <Grid key={index}>
                  <Grid className={classes.cardInnerContainer}>
                    <Grid className={classes.serviceAgreementSection}>
                      <Typography
                        fontSize="14px"
                        fontType="medium"
                        textColor={`${patientAccessTheme.palette.text.highemphasis}`}
                        styleProps={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        {card?.service_agreement_name}
                        <span
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            return handleDraftOnClick(card);
                          }}
                        >
                          <ArrowOutword />
                        </span>
                      </Typography>
                      <Grid className={classes.organisationRow}>
                        <Grid className={classes.organisationItem}>
                          <Typography
                            fontSize="12px"
                            textColor={`${patientAccessTheme.palette.text.lowemphasis}`}
                          >
                            {card?.service_agreement_name ===
                            'Summary Plan Docs'
                              ? 'Plan Type'
                              : 'Vendor'}
                          </Typography>
                          <Tooltip
                            disableFocusListener
                            placement={'right-end'}
                            title={
                              <Typography fontSize="12px">
                                {/* {card?.health_care_partner_name} */}
                                {card?.health_care_partner_name}
                              </Typography>
                            }
                            arrow={true}
                          >
                            <div>
                              <Typography
                                fontSize="14px"
                                textColor={'#2E2F33'}
                                noWrap
                                styleProps={{
                                  maxWidth: card?.effective_date
                                    ? '120px'
                                    : '240px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                {truncateString(
                                  card?.health_care_partner_name,
                                  card?.effective_date ? 10 : 100,
                                )}
                              </Typography>
                            </div>
                          </Tooltip>
                        </Grid>
                        {card?.effective_date && (
                          <Grid className={classes.organisationItem}>
                            <Typography
                              fontSize="12px"
                              textColor={`${patientAccessTheme.palette.text.lowemphasis}`}
                            >
                              Effective Date
                            </Typography>
                            <Typography
                              fontSize="14px"
                              textColor={'#2E2F33'}
                              noWrap
                              styleProps={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {moment(card?.effective_date).format(
                                'MMM DD, YYYY',
                              )}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>

                    {/* Right section: Reports */}
                    <Grid className={classes.reportMainContainer}>
                      {(() => {
                        const evals = card?.evaluations || [];
                        const isExpanded = showAll;
                        const hasMoreThanFour = evals?.length > 4;
                        const displayedEvaluations = isExpanded
                          ? evals
                          : hasMoreThanFour
                          ? evals.slice(0, 3)
                          : evals.slice(0, 4);

                        return displayedEvaluations.map((item, evalIndex) => (
                          <Grid key={evalIndex}>
                            <span
                              className={classes.reportsLabelContainer}
                              onClick={() => {
                                if (item.status === 'Ready') {
                                  reportHandleOnClick(
                                    item?.report_name,
                                    item?.contract_id,
                                    item?.status,
                                    item?.compare_agreement_id,
                                    card,
                                  );
                                }
                              }}
                            >
                              <DottedText
                                text={item.report_name}
                                truncateText={true}
                                truncateWidth="200px"
                                typographyStyles={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  fontSize: '14px',
                                  display: 'block',
                                  maxWidth: '100%',
                                  cursor:
                                    item?.status !== 'Ready'
                                      ? 'no-drop'
                                      : 'pointer',
                                  color:
                                    item?.status !== 'Ready'
                                      ? patientAccessTheme.palette.grey[500]
                                      : patientAccessTheme.palette.primary[500],
                                }}
                              />
                              {item?.status !== 'Ready' ? (
                                <img
                                  src={loader}
                                  alt="img"
                                  width="32px"
                                  height="32px"
                                />
                              ) : (
                                <CheckCircle />
                              )}
                            </span>
                          </Grid>
                        ));
                      })()}

                      {!showAll && card?.evaluations?.length > 4 && (
                        <Grid
                          className={classes.reportsExpandContainer}
                          onClick={() =>
                            setExpandedCards((prev) => ({
                              ...prev,
                              [index]: !prev[index],
                            }))
                          }
                        >
                          <DottedText
                            text={`+ ${card?.evaluations?.length - 3} More`}
                            typographyStyles={{ fontSize: '14px' }}
                          />
                        </Grid>
                      )}

                      {showAll && card?.evaluations?.length > 4 && (
                        <Grid
                          className={classes.reportsExpandContainer}
                          onClick={() =>
                            setExpandedCards((prev) => ({
                              ...prev,
                              [index]: !prev[index],
                            }))
                          }
                        >
                          <DottedText
                            text={`− ${card?.evaluations?.length - 3} Less`}
                            typographyStyles={{ fontSize: '14px' }}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              );
            })
          ) : (
            <Grid className={classes.noDataBottomCardContainer}>
              <NoTabsData icon={<Unfinished />} label="No Data Found !" />
            </Grid>
          )}
        </Grid>
      </Grid>

      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </Grid>
  );
};

export default DraftsTab;
